import { Grid, Typography } from '@mui/material';
import { RootStateType } from '@Store';
import React from 'react';
import { useSelector } from 'react-redux';

function ChargeTitle() {
  const shipmentById = useSelector((state: RootStateType) => state.adminShipment.shipmentById);
  const { sellingPricing } = shipmentById || {};

  return (
    <Grid container justifyContent={'space-between'} sx={{ mb: 1, alignItems: 'center' }}>
      <Typography sx={{ fontSize: '16px', fontWeight: 500, color: 'primary.main' }}>Payment</Typography>
      <Typography sx={{ fontSize: '14px', fontWeight: 600, color: 'primary.main' }}>
        Amount {sellingPricing?.currency || ''}
      </Typography>
    </Grid>
  );
}

export default ChargeTitle;
